import { FETCH_DP_URL } from './available'

export default {
  [FETCH_DP_URL](state, url) {
    state.dpURL = url + '/'
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/fetch-dp-url.js